import { Dispatch } from "redux";
import request from "../../util/request";
import actions from "../../util/actions";
import errorHandler from "../../util/error-handler";

export const getDiscipleshipClasses = (search: string, page: number, per_page: number) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.DISCIPLESHIP_CLASSES_HTTP_LOADING
    });

    request({
      method: "get",
      pathname: "getDiscipleshipClasses",
      params: { search, page, per_page }
    })
      .then((response) => {
        dispatch({
          type: actions.DISCIPLESHIP_CLASSES_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });

        dispatch({
          type: actions.SET_DISCIPLESHIP_CLASSES_DETAILS,
          payload: {
            ...response.data.content
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.DISCIPLESHIP_CLASSES_HTTP_ERROR, error, dispatch);
      });
  };
};
